import { render, staticRenderFns } from "./AddDrugs.vue?vue&type=template&id=4b557432&scoped=true"
import script from "./AddDrugs.vue?vue&type=script&lang=js"
export * from "./AddDrugs.vue?vue&type=script&lang=js"
import style0 from "./AddDrugs.vue?vue&type=style&index=0&id=4b557432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b557432",
  null
  
)

export default component.exports